import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const HelpBubblesIcon = ({ color = '#B5BCBD', size = '24', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    {...props}
  >
    <path
      fill={color}
      d="M14.6 6.4c-5.1 0-9.3 3.6-9.3 8.1s4.1 8.1 9.3 8.1c1.8 0 3.6-.5 5-1.3 1.3.8 2.7.7 3.5.6.2 0 .3-.3.1-.5-.8-.5-1.2-1.2-1.5-1.9 1.3-1.4 2.1-3.2 2.1-5.1.1-4.4-4.1-8-9.2-8zm.6 11.4c0 .2-.2.4-.4.4h-.9c-.2 0-.4-.2-.4-.4v-.6c0-.2.2-.4.4-.4h.9c.2 0 .4.2.4.4v.6zm1.5-3.6c-.2.3-.5.6-.9.8-.2.1-.3.3-.4.4 0 .1-.1.2-.1.4 0 .1-.1.2-.2.2H14c-.1 0-.3-.1-.2-.3 0-.3.1-.6.2-.7.1-.2.4-.5.9-.8.2-.1.4-.3.5-.5.1-.2.2-.4.2-.7 0-.3-.1-.5-.2-.7-.1-.2-.3-.2-.6-.2-.2 0-.4.1-.5.2-.1.1-.1.2-.2.3 0 .2-.2.3-.4.3h-1.1c-.1 0-.2-.1-.2-.2 0-.6.2-1 .6-1.3.4-.3 1-.5 1.8-.5s1.4.2 1.8.6c.4.4.7.9.7 1.6-.2.4-.4.8-.6 1.1zM1.9 12.3C.8 11.2.2 9.7.2 8.1c0-3.7 3.4-6.7 7.7-6.7 2.9 0 5.4 1.4 6.7 3.4-5.7 0-10.4 3.9-10.9 8.9-1.1.6-2.2.6-2.9.5-.2 0-.2-.3-.1-.4.6-.4 1-1 1.2-1.5z"
    />
  </svg>
);

HelpBubblesIcon.propTypes = propTypes;

export default HelpBubblesIcon;
